/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiescolumnconversion2Inputs */

const en_opportunitiescolumnconversion2 = /** @type {(inputs: Opportunitiescolumnconversion2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan → account`)
};

const de_opportunitiescolumnconversion2 = /** @type {(inputs: Opportunitiescolumnconversion2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan → Konto`)
};

/**
* | output |
* | --- |
* | "Scan → account" |
*
* @param {Opportunitiescolumnconversion2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiescolumnconversion2 = /** @type {((inputs?: Opportunitiescolumnconversion2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiescolumnconversion2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiescolumnconversion2(inputs)
	return de_opportunitiescolumnconversion2(inputs)
});
export { opportunitiescolumnconversion2 as "opportunitiesColumnConversion" }